import React, { useState } from 'react';
import { ArrowRightIcon, LightbulbIcon, SkipForwardIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { SortingCard } from '../story/SortingCard';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { sortCards, sortExample, sortValueLabels } from '../../data/savanna';
export function SortingScreen() {
  const {
    state,
    dispatch,
    announce
  } = useDemo();
  const [showExample, setShowExample] = useState(false);
  return <ScreenContainer data-id="element-287" data-mp="3ve2r53ancwi8">
      <ScreenHeading eyebrow="Signal or Static" data-id="element-288" data-mp="3vd9vaxd87rev">Where would you start?</ScreenHeading>
      <p className="mt-3 max-w-prose" data-id="element-289" data-mp="3qgszri3p6arr">There may be more than one useful answer. You can change your mind.</p>

      <ul className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-290" data-mp="213fnn6pcfig3">
        {sortCards.map(card => <SortingCard key={card.id} card={card} value={state.sortingSelections[card.id]} onSelect={value => {
        dispatch({
          type: 'SORT',
          card: card.id,
          value
        });
        announce(`${card.label}: ${sortValueLabels[value]}. ${card.feedback[value]}`);
      }} data-id="element-291" data-mp="1w4cqe8flugio" />)}
      </ul>

      <div className="mt-6" data-id="element-292" data-mp="1o06emdbzibj1">
        <Button variant="secondary" aria-expanded={showExample} onClick={() => setShowExample(value => !value)} icon={<LightbulbIcon size={18} aria-hidden="true" data-id="element-294" data-mp="1wz9wjdzf0kvy" />} data-id="element-293" data-mp="1o1hied5fjja5">
          {showExample ? 'Hide the example' : 'See one example'}
        </Button>
        {showExample && <div className="anim-enter mt-4 rounded-2xl border border-line bg-paper p-5 hc-strong" data-id="element-295" data-mp="26xz5uid8wx0l">
            <h2 className="font-display text-xl font-semibold text-forest" data-id="element-296" data-mp="7leibpbpwk4g">One possible first sort</h2>
            <table className="mt-3 w-full text-left" data-id="element-297" data-mp="cjy51ry4xzxv">
              <caption className="sr-only" data-id="element-298" data-mp="ckhr9kutjahp">An example sort. Your own choices are not changed.</caption>
              <thead data-id="element-299" data-mp="4js73bai2ilt">
                <tr className="border-b border-line" data-id="element-300" data-mp="3vpuomwovtfsz">
                  <th scope="col" className="py-2 pr-4 text-sm font-bold text-teal" data-id="element-301" data-mp="3vr4nho3k6s0o">
                    Signal
                  </th>
                  <th scope="col" className="py-2 text-sm font-bold text-teal" data-id="element-302" data-mp="efd40v0posop">
                    Example sort
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-303" data-mp="ngl159rhrnh7">
                {sortCards.map(card => <tr key={card.id} className="border-b border-line last:border-0" data-id="element-304" data-mp="ii9qwxxabayg">
                    <td className="py-2 pr-4" data-id="element-305" data-mp="x8qqebqczqsp">{card.label}</td>
                    <td className="py-2 font-bold text-forest" data-id="element-306" data-mp="xa1ukcnpv0kc">{sortValueLabels[sortExample[card.id]]}</td>
                  </tr>)}
              </tbody>
            </table>
            <p className="mt-3" data-id="element-307" data-mp="1695hjrq08044">This is one possible first sort, not the only one. Your choices above stay as they are.</p>
          </div>}
      </div>

      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-308" data-mp="1kvcg4jmnfaw9">
        <Button variant="secondary" onClick={() => dispatch({
        type: 'GO',
        screen: 'action',
        recap: 'You skipped the sorting. Your Field Guide tools stay the same.'
      })} icon={<SkipForwardIcon size={18} aria-hidden="true" data-id="element-310" data-mp="1gs656yolcvjg" />} data-id="element-309" data-mp="1pup4x9x2ys1h">
          Skip this activity
        </Button>
        <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'action'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-312" data-mp="16xwc1ertrt7o" />} data-id="element-311" data-mp="1230a9mwsdrhd">
          Choose a next step
        </Button>
      </ActionRow>
    </ScreenContainer>;
}